export default function ReportLoader({ label }: { label: string }) {
  return (
    <div role="status" className="flex items-center justify-center gap-2 py-6">
      <span
        aria-hidden="true"
        className="h-5 w-5 animate-spin rounded-full border-2 border-gray-200 border-t-blue-600 motion-reduce:animate-none"
      />
      <span>{label}</span>
    </div>
  );
}
